import {matchPath} from "react-router-dom-v5-compat";

import {
    getAdminToolsByUrlSlug,
    getParentToolsByActivitySlug,
    getParentToolsByUrlSlug,
    getToolsByActivitySlug,
    getToolsByUrlSlug,
    type Tool,
} from "./ai-tools-list.ts";

// sync-start:khanmigo-tools-paths 483583598 apps/khanacademy/src/page-package/util.ts
const PARENT_KHANMIGO_TOOLS_PATH: string = "/parent/khanmigo-tools";
// sync-end:khanmigo-tools-paths

/**
 * Determine if a path represents a Khanmigo teacher tool page
 */
export const isTeacherToolPage = (pathname: string): boolean => {
    return !!getTeacherToolFromPath(pathname);
};

/**
 * Extracts the teacher tool slug from a given pathname, if the path matches
 * the expected route (/teacher/khanmigo-tools/:tool). If not, returns null.
 */
export const getTeacherToolFromPath = (pathname: string): Tool | null => {
    const match = matchPath(`${TEACHER_KHANMIGO_TOOLS_PATH}/:tool`, pathname);

    const slug = match?.params.tool;
    if (!slug) {
        return null;
    }

    return getToolsByUrlSlug()[slug] ?? null;
};

export const TEACHER_KHANMIGO_TOOLS_PATH: string = "/teacher/khanmigo-tools";

export const mapActivityToTeacherToolsPath = (
    activitySlug: string,
): string | null => {
    const toolSlug = getToolsByActivitySlug()[activitySlug]?.urlSlug;
    return toolSlug ? `${TEACHER_KHANMIGO_TOOLS_PATH}/${toolSlug}` : null;
};

export const PARENT_SETTINGS_PATH: string = "/parent/settings";
export const PARENT_DASHBOARD_PATH: string = "/parent/children";
export const PARENT_ACTIVITY_REPORT_PATH: string = "/parent/activity-report";
export const PARENT_ASSIGNMENTS_PATH: string = "/parent/assignments";
export const ADMIN_KHANMIGO_TOOLS_PATH: string =
    "/districts/khanmigo-activities";
/**
 * Determine if a path represents a Khanmigo parent tool page
 */
export const isParentToolPage = (pathname: string): boolean => {
    return !!getParentToolFromPath(pathname);
};

/**
 * Extracts the parent tool slug from a given pathname, if the path matches
 * the expected route (/parent/khanmigo-tools/:tool). If not, returns null.
 */
export const getParentToolFromPath = (pathname: string): Tool | null => {
    const match = matchPath(`${PARENT_KHANMIGO_TOOLS_PATH}/:tool`, pathname);

    const slug = match?.params.tool;
    if (!slug) {
        return null;
    }

    return getParentToolsByUrlSlug()[slug] ?? null;
};

export const mapActivityToParentToolsPath = (
    activitySlug: string,
): string | null => {
    const toolSlug = getParentToolsByActivitySlug()[activitySlug]?.urlSlug;
    return toolSlug ? `${PARENT_KHANMIGO_TOOLS_PATH}/${toolSlug}` : null;
};

export const isAdminToolPage = (pathname: string): boolean => {
    return !!getAdminToolFromPath(pathname);
};

export const getAdminToolFromPath = (pathname: string): Tool | null => {
    const match = matchPath(`${ADMIN_KHANMIGO_TOOLS_PATH}/:tool`, pathname);

    const slug = match?.params.tool;
    if (!slug) {
        return null;
    }

    return getAdminToolsByUrlSlug()[slug] ?? null;
};
